import { render, staticRenderFns } from "./ResinReferencePriceMaintain.vue?vue&type=template&id=3fb196bf&scoped=true"
import script from "./ResinReferencePriceMaintain.vue?vue&type=script&lang=js"
export * from "./ResinReferencePriceMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb196bf",
  null
  
)

export default component.exports